<script>
import StripeForm from "@/components/Payment/StripeForm.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: { StripeForm },
  data() {
    return {
      has_subscription: false,
      user: null,
      swal_confirm_button_class:
        "btn btn-bumblebee btn-garden-help mx-3",
      swal_cancel_button_class:
        "btn btn-bumblebee btn-garden-help mx-3",
      swal_container_class: "swal-container-garden-help",
      currency: null,
      pricesList: []
    }
  },
  mounted() {
    let user = JSON.parse(window.localStorage.getItem("user"));
    // Check if has subscription 
    this.has_subscription = !!user.has_subscription
    this.user = user;
    this.getUserLocation();
    this.getPricesList();
  },
  methods: {
    moment: moment,
    cancelSubscription() {
      this.$fire({
            text: "Are you sure that you need to cancel your subscription?",
            // type: "success",
            // timer: 3000,
            icon: "question",
            showDenyButton: true,
            showCancelButton: true,
            customClass: {
              // container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
              cancelButton: this.swal_cancel_button_class
            },
            confirmButtonText: "Yes",
            denyButtonText: `No`,
            reverseButtons: true,
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !Swal.isLoading(),
            preConfirm: async () => {
              const cancel = await axios.post("/payment/stripe/subscriptions/subscriptions/cancel", {cancelNow: true}, {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      client: 'GARDENHELP',
                      Authorization:
                          "Bearer " +
                          JSON.parse(window.localStorage.getItem("user")).access_token,
                  },
              })
              
              if (cancel.status === 200) {
                return cancel;
              }
              console.log(cancel);
            }
          }).then((status) => {
            console.log('cancelation',status);

            if (status.value.status === 200) {

              this.$fire({
                title: "Your subscription has been cancelled, after the current period you will not be charged",
                type: "success",
              });
              localStorage.removeItem("user");
              window.location.reload();
            } else {
              this.$fire({
                title: status.value.message,
                type: "info",
              });
            }
          });
    },
    async getUserLocation() {
      try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        this.currency = data.currency == 'GBP' ? data.currency : 'EUR'; // e.g., "EUR"
      } catch (error) {
        console.error('Error getting location:', error);
      }
    },
    async getPricesList() {
      const pricesList = await axios.get("/payment/stripe/subscriptions/plans", {
          headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: 'GARDENHELP',
              Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
          },
      })
      
      // if (pricesList.status === 200) {
      //   return pricesList;
      // }
      this.pricesList = pricesList.data.data;
      console.log('pricesList', this.pricesList);
    },
    getPlanPriceByCurrency() {
      return this.pricesList.find(plan => plan.currency === this.currency.toLowerCase());
    }
  }
}
</script>

<template>
    <div>
      <div v-if="has_subscription">
        <p class="form-label-garden-help my-2 float-left w-auto fw-bold ">
            Your subscription valid until: {{ moment(user.subscription_details.ends_at).format('MMMM Do YYYY') }}
        </p>

        <b-button v-if="!is_loading_connect" variant="garden-help-primary-danger"
            class="btn-bumblebee btn-garden-help btn-danger float-right" @click="cancelSubscription">
            Cancel
        </b-button>
      </div>
      <div v-else>

        <p>Subscribe now for just <span class="fw-bold">{{ parseFloat(getPlanPriceByCurrency().unit_amount / 100).toFixed(2) }} {{currency}}/month</span> and enjoy full access to all premium features!</p>
        <StripeForm
          client_name="GARDENHELP"
          form_group_class="form-group-garden-help"
          label_class="form-label-garden-help"
          input_class="form-control-garden-help"
          button_text="Subscribe"
          button_variant="garden-help-secondary"
          button_class="btn-garden-help w-100"
          :pricePlan="getPlanPriceByCurrency()"
        />
      </div>
    </div>
</template>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/SubscriptionDetailsView.vue